var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/** World-space axis-aligned bounds for a node (with optional padding). */
export function getWorldBounds(node, padding) {
    var e_1, _a;
    if (padding === void 0) { padding = 2; }
    var b = node.getBounds();
    var wm = node.getWorldMatrix();
    var corners = [
        wm.transformPoint(b.x, b.y),
        wm.transformPoint(b.x + b.width, b.y),
        wm.transformPoint(b.x, b.y + b.height),
        wm.transformPoint(b.x + b.width, b.y + b.height),
    ];
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    try {
        for (var corners_1 = __values(corners), corners_1_1 = corners_1.next(); !corners_1_1.done; corners_1_1 = corners_1.next()) {
            var c = corners_1_1.value;
            minX = Math.min(minX, c.x);
            minY = Math.min(minY, c.y);
            maxX = Math.max(maxX, c.x);
            maxY = Math.max(maxY, c.y);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (corners_1_1 && !corners_1_1.done && (_a = corners_1.return)) _a.call(corners_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        x: minX - padding,
        y: minY - padding,
        width: maxX - minX + padding * 2,
        height: maxY - minY + padding * 2,
    };
}
/** True if node or any descendant is dirty. */
export function isSubtreeDirty(node) {
    var e_2, _a;
    if (node.isDirty())
        return true;
    if ('children' in node) {
        try {
            for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (isSubtreeDirty(child))
                    return true;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    return false;
}
/** Collect all listening leaf nodes for spatial indexing. */
export function collectHitTargets(root, out) {
    var e_3, _a;
    if (out === void 0) { out = []; }
    try {
        for (var _b = __values(root.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            if (!child.visible || !child.listening)
                continue;
            if ('children' in child && child.children.length > 0) {
                collectHitTargets(child, out);
            }
            else {
                out.push(child);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return out;
}
/** Count nodes in subtree. */
export function countNodes(root) {
    var e_4, _a;
    var n = 0;
    try {
        for (var _b = __values(root.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            n++;
            if ('children' in child)
                n += countNodes(child);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return n;
}
